import React from "react";
import PropTypes from "prop-types";
import Icon from "../../../../../atoms/icon";
import { Link } from "@quintype/components";
import { isPremium } from "../../../../../../../isomorphic/data/story";
import styles from "./styles.m.css";

class TextStoryHeader extends React.Component {
  constructor(props) {
    super(props);

    this.dropdown = null;

    this.state = {
      dropdown: false,
      showRelativeTime: false
    };

    this.handleDropdownClick = this.handleDropdownClick.bind(this);
    this.handleExternalClick = this.handleExternalClick.bind(this);
  }

  componentDidMount() {
    document.addEventListener("click", this.handleExternalClick);
    this.setState({ showRelativeTime: true });
  }

  componentWillUnmount() {
    document.removeEventListener("click", this.handleExternalClick);
  }

  handleExternalClick(e) {
    this.setState({ dropdown: false });
  }

  handleDropdownClick = e => {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
    this.setState({ dropdown: !this.state.dropdown });
  };

  render() {
    const { story, episodes, className, readMore = true } = this.props;

    return (
      <div className={`${styles["story-header"]} ${className}`}>
        {!isPremium(story)}
        {story.headline && <h1 className={styles.headline}>{story.headline}</h1>}
        {readMore === true &&
          episodes && (
            <div className={styles["episode-dropdown-base"]}>
              <button
                aria-label="toggle dropdown"
                role="button"
                className={styles["selected-episode"]}
                onClick={this.handleDropdownClick}
                ref={element => {
                  this.dropdown = element;
                }}
              >
                <span className={styles["selected-episode-text"]}>{story.headline}</span>
                <Icon type={this.state.dropdown ? "angle-up" : "angle-down"} className={styles["dropdown-icon"]} />
              </button>
              <ul className={`${styles["episodes-dropdown"]} ${this.state.dropdown ? "" : "hidden"}`}>
                {episodes.map(episode => (
                  <li key={episode.id} className={styles.episode}>
                    <Link aria-label="Episode" href={episode.url} className={styles["episode-link"]}>
                      {episode.headline}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          )}
      </div>
    );
  }
}

TextStoryHeader.propTypes = {
  story: PropTypes.shape({
    headline: PropTypes.string
  }),
  episodes: PropTypes.arrayOf(
    PropTypes.shape({
      headline: PropTypes.string,
      slug: PropTypes.string
    })
  ),
  className: PropTypes.string,
  config: PropTypes.shape({
    cinemaMode: PropTypes.bool,
    disableAuthorLink: PropTypes.bool
  }),
  readMore: PropTypes.bool
};

export default TextStoryHeader;
